//#################### Path :: app/scripts/base.js//####################

$(function () {
    $.migrateMute = true;

    var bottomScroll = false;

    var modal = document.querySelector('.modalContent');

    if (modal) {
        modal.addEventListener('scroll', function() {
            if (!bottomScroll) {
                var scrollTop = document.querySelector('.modalContent').scrollTop;
                var height = document.querySelector('.modalContent').scrollHeight;

                var scrollEnd = height * .75;

                if (scrollTop > scrollEnd && !bottomScroll) {
                    document.querySelector('#btn-conditions').removeAttribute('disabled');
                    document.querySelector('label[for=conditions]').style.pointerEvents = 'auto';
                    bottomScroll = true;

                    document.querySelector('#conditions').checked = true;
                }
            }
        });
    }

    
});





